export const STSG_DATA = {
  receptivo: [
    {id:1, a:'El niño está sentado', b:'El niño no está sentado', correct:1},
    {id:2, a:'El gato está encima de la caja', b:'El gato está adentro de la caja', correct:2},
    {id:3, a:'El está subiendo', b:'Ella está subiendo', correct:2},
    {id:4, a:'El perro está detrás de la silla', b:'El perro está debajo de la silla', correct:1},
    {id:5, a:'Están comiendo', b:'Está comiendo', correct:2},
    {id:6, a:'El libro es de él', b:'El libro es de ella', correct:1},
    {id:7, a:'El niño se cayó', b:'El niño se cae', correct:1},
    {id:8, a:'Alguien está en la mesa', b:'Algo está en la mesa', correct:2},
    {id:9, a:'El niño la está llamando', b:'El niño lo está llamando', correct:2},
    {id:10, a:'Este es mi papá', b:'Aquel es mi papá', correct:1},
    {id:11, a:'El niño está tomando helado', b:'El niño estaba tomando helado', correct:1},
    {id:12, a:'¿Dónde está la niña?', b:'¿Quién es la niña?', correct:2},
    {id:13, a:'El niño tiene el pájaro', b:'El niño tenía el pájaro', correct:1},
    {id:14, a:'La niña las tiene', b:'La niña la tiene', correct:1},
    {id:15, a:'Esta es mi cama', b:'Esta es nuestra cama', correct:2},
    {id:16, a:'El niño se ve', b:'El niño lo ve', correct:2},
    {id:17, a:'La niña subirá', b:'La niña subió', correct:1},
    {id:18, a:'Mira a quien llegó', b:'Mira lo que llegó', correct:2},
    {id:19, a:"La mamá dice, 'Se lo dio'", b:"La mamá dice, 'Me lo dio'", correct:2},
    {id:20, a:'La mamá va a comprar pan', b:'La mamá fue a comprar pan', correct:1},
    {id:21, a:'Este es un avión', b:'Ese es un avión', correct:1},
    {id:22, a:'El papá es alto', b:'El papá está alto', correct:2},
    {id:23, a:'El niño es llamado por la niña', b:'La niña es llamada por el niño', correct:1}
  ],
  expresivo: [
    {id:1, a:'La puerta no está cerrada', b:'La puerta está cerrada', correct:1},
    {id:2, a:'El perro está encima del auto', b:'El perro está adentro del auto', correct:1},
    {id:3, a:'El gato está debajo de la silla', b:'El gato está detrás de la silla', correct:2},
    {id:4, a:'Él ve al gato', b:'Ella ve al gato', correct:1},
    {id:5, a:'Alguien está en la silla', b:'Algo está en la silla', correct:2},
    {id:6, a:'El sombrero es de ella', b:'El sombrero es de él', correct:2},
    {id:7, a:'Está durmiendo', b:'Están durmiendo', correct:2},
    {id:8, a:'El niño se vistió', b:'El niño se viste', correct:1},
    {id:9, a:'La niña está escribiendo', b:'La niña estaba escribiendo', correct:1},
    {id:10, a:'La niña la ve', b:'La niña lo ve', correct:2},
    {id:11, a:'El niño tenía el globo', b:'El niño tiene el globo', correct:1},
    {id:12, a:'La niña lo lleva', b:'La niña los lleva', correct:1},
    {id:13, a:'Este es mi amigo', b:'Aquel es mi amigo', correct:2},
    {id:14, a:'El niño lo lava', b:'El niño se lava', correct:2},
    {id:15, a:'Este es su perro', b:'Este es nuestro perro', correct:1},
    {id:16, a:'La niña comió', b:'La niña comerá', correct:1},
    {id:17, a:'Esa es mi muñeca', b:'Esta es mi muñeca', correct:2},
    {id:18, a:'¿Quién está en la puerta?', b:'¿Qué está en la puerta?', correct:1},
    {id:19, a:'¿Dónde está el niño?', b:'¿Quién es el niño?', correct:2},
    {id:20, a:'El niño va a cortarse el pelo', b:'El niño fue a cortarse el pelo', correct:2},
    {id:21, a:"El niño dice, 'Me la dio'", b:"El niño dice, 'Se la dio'", correct:1},
    {id:22, a:'El niño es alto', b:'El niño está alto', correct:2},
    {id:23, a:'La niña es empujada por el niño', b:'El niño es empujado por la niña', correct:1}
  ]
};
